import { render, staticRenderFns } from "./StaticSectionDomain.vue?vue&type=template&id=9e4e7112"
import script from "./StaticSectionDomain.vue?vue&type=script&lang=js"
export * from "./StaticSectionDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports